const Facebook = () => {
  return (
    <svg
      className='social__svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        className='social__path'
        d='M6 5.33333H4V8H6V16H9.33333V8H11.7613L12 5.33333H9.33333V4.222C9.33333 3.58533 9.46133 3.33333 10.0767 3.33333H12V0H9.46133C7.064 0 6 1.05533 6 3.07667V5.33333Z'
        fill='white'
      />
    </svg>
  );
};
export default Facebook;
